import {
  PLEASE_FILL_CURRENT_PASSWORD,
  PLEASE_FILL_NEW_PASSWORD,
  PLEASE_FILL_VERIFY_PASSWORD,
} from "@/ChangePassword/store/Messages";
import { IChangePasswordRequest } from "@/ChangePassword/services";
import { PASSWORD_ENDPOINT } from "@/ChangePassword/config";
import { HttpClient } from "@/App/services/HttpClient";
import { HttpErrorParser } from "@/App/services/HttpErrorParser";
import router from "@/App/router";
import { LoggerService as lgg } from "vue-components-library";
import { AxiosError } from "axios";

const LOG_TAG = "[CHANGE PASSWORD STORE]";

const state = getDefaultState();

function getDefaultState() {
  return {
    errorMessage: "",
    currentPasswordError: "",
    newPasswordError: "",
    verifyPasswordError: "",
    isLoading: false,
  };
}
const actions = {
  async changePassword({ commit, dispatch }: any, data: IChangePasswordRequest) {
    let changePasswordResponse;
    if (!data.currentPassword || !data.newPassword || !data.verifyPassword) {
      if (!data.currentPassword) {
        commit("SET_CURRENT_PASSWORD_ERROR", PLEASE_FILL_CURRENT_PASSWORD);
      }
      if (!data.newPassword) {
        commit("SET_NEW_PASSWORD_ERROR", PLEASE_FILL_NEW_PASSWORD);
      }
      if (!data.verifyPassword) {
        commit("SET_VERIFY_PASSWORD_ERROR", PLEASE_FILL_VERIFY_PASSWORD);
      }
    }
    try {
      changePasswordResponse = await HttpClient.post(PASSWORD_ENDPOINT.CHANGEPASSWORD, data);
      lgg.info(`${LOG_TAG} User password changed`);
      router.push({ name: "settings" });
    } catch (error) {
      dispatch("setGeneralError", HttpErrorParser.parse(error as AxiosError));
    }
    return changePasswordResponse;
  },
  setGeneralError({ commit }: any, error: any) {
    commit("SET_GENERAL_ERROR", error);
    lgg.error(`${LOG_TAG} Failed to change User password`);
  },
  resetState({ commit }: any) {
    commit("RESET_STATE");
  },
};
const mutations = {
  SET_GENERAL_ERROR(state: any, message: string) {
    state.errorMessage = message;
  },
  SET_CURRENT_PASSWORD_ERROR(state: any, message: string) {
    state.currentPasswordError = message;
  },
  SET_NEW_PASSWORD_ERROR(state: any, message: string) {
    state.newPasswordError = message;
  },
  SET_VERIFY_PASSWORD_ERROR(state: any, message: string) {
    state.verifyPasswordError = message;
  },
  SET_LOADING(state: any, message: string) {
    state.isLoading = message;
  },
  CLEAR_ERRORS(state: any) {
    state.errorMessage = "";
    state.currentPasswordError = "";
    state.newPasswordError = "";
    state.verifyPasswordError = "";
  },
  RESET_STATE(state: any) {
    const initialState: any = getDefaultState();

    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
